export default __webpack_public_path__ + "static/media/vip_locations_icons_school.97543d09.svg";